import axiosWrapper from '@/utils/request'

const fetchPDFData = (docId) => {
  return axiosWrapper({
    method: 'GET',
    url: `/v1/documents/view_esign_document?doc_id=${docId}`,
    responseType: 'blob'
  })
}

const postClickWrap = (docId, signature) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v1/documents/do_clickwrap`,
    data: {
      doc_id: docId,
      typed_in_name: signature
    }
  })
}

export default {
  fetchPDFData,
  postClickWrap
}
